var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card o-card__padding-small"},[_c('CycleForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }